﻿@if (columnList) {
  <div class="rdo-inline">
    <table class="table table-nowrap rdo-table-pretty" [ngClass]="{'rdo-expander-gray': hasOneColumnAndNotLockedOrApplyColor(group)}" [ngStyle]="{width: fullWidth.toString() + 'px'}">
      <colgroup>
      @for (c of columns; track c) {
        <col [ngStyle]="{'width': (c.width ? c.width : 110) + 'px'}">
      }
    </colgroup>
    <thead>
      <tr>
        <th [attr.colspan]="columnList.length" [ngClass]="{'column-selector':showColumnSelector}">
          <div style="position: fixed; right: 17px; top: 142px; z-index: 5000;">
            @if (showColumnSelector) {
              <rdo-column-selector
                [gridConfig]="gridConfig"
                (visibilityChanged)="visibilityChanged.next(gridConfig)"
                (downloadExcelClick)="downloadExcelClick.next(gridConfig)"
                (deleteClick)="deleteClick.next()"
              ></rdo-column-selector>
            }
          </div>
          {{tableTitle | translate}}
          @if (!group.locked) {
            <a (click)="toggleColumnVisibility(group)"
              title="{{'main.core.tables.common.hide_column_group' | translate}}">
              <img class="close" src="/assets/images/close.png">
            </a>
          }
        </th>
      </tr>
    </thead>
    <tbody>
      <tr [ngStyle]="headerStyle">
        @for (c of columns; track c) {
          <th [ngStyle]="c.headerStyle">
            <rdo-sort-header
              [enableOrdering]="filterSortableColumns(c)"
              [column]="c"
              [currentSortColumn]="sortOn !== 'Description' ? sortOn : undefined"
              [desc]="desc"
              (descChange)="setSortDirection(!desc)"
              (columnClick)="setSortColumn(c)"
              [sortInProgress]="sortInProgress">
            </rdo-sort-header>
          </th>
        }
      </tr>
      @for (r of gridData; track r; let rowIndex = $index) {
        <tr [ngClass]="{'clickable-row' : isExpandable(), 'table-expanded-row-first': r.data.expanded }" (click)="toggleChildren(r, rowIndex)">
          @for (c of r.cells; track c; let i = $index) {
            <td [ngStyle]="c.style" [ngClass]="c.class" title="{{translatePossibleDate(c)}}">
              @if (r.data.chidlLoading && showExpansionIndicator && i === 0) {
                <img src="/assets/images/loader-sm.gif" width="20" height="20" style="width:16px;height:16px;"/>
              }
              @if (isExpandable() && showExpansionIndicator && i === 0 && !r.data.chidlLoading) {
                <i class="fa fa-fw"
                [ngClass]="{ 'fa-angle-right' : !r.data.expanded, 'fa-angle-down' : r.data.expanded }" ></i>
              }
              @if (!c.href && !c.linkDsl && isBool(c.value) && c.value) {
                <i class="fa fa-check"></i>
              }
              @if (c.linkDsl) {
                <a (click)="clickCellLink(c.config, r.data.raw)"  [routerLink]="c.linkDsl"> {{ c.value | translate }}</a>
              }
              @if (c.href && !c.linkDsl) {
                <a (click)="clickCellLink(c.config, r.data.raw)" href="{{c.href}}">{{ c.value | translate }}</a>
              }
              @if (!c.href && !c.linkDsl && !isBool(c.value)) {
                <span>{{ translatePossibleDate(c) }}</span>
              }
            </td>
          }
        </tr>
        @if (isExpandable()) {
          <tr>
            <td [attr.colspan]="columnList.length" style="border: none; padding: 0;">
              <div class="rdo-expander-row" [style.height]="childrenHeightStyle(r)">
                <table class="table table-nowrap rdo-table-pretty" style="margin-bottom: 0;">
                  <colgroup>
                  @for (c of columns; track c) {
                    <col [ngStyle]="{'width': (c.width ? c.width : 110) + 'px'}">
                  }
                </colgroup>
                <tbody>
                  @for (child of r.childRows; track child) {
                    <tr class="table-expanded-row">
                      @for (c of child.cells; track c) {
                        <td [ngStyle]="c.style" [ngClass]="c.class" title="{{translatePossibleDate(c)}}">
                          @if (c.linkDsl) {
                            <a (click)="clickCellLink(c.config, child.data.raw, r.data.raw)"  [routerLink]="c.linkDsl"> {{ c.value }}</a>
                          }
                          @if (c.href && !c.linkDsl) {
                            <a (click)="clickCellLink(c.config, child.data.raw, r.data.raw)" href="{{c.href}}"> {{ c.value }}</a>
                          }
                          @if (!c.href && !c.linkDsl && isBool(c.value) && c.value) {
                            <i class="fa fa-check"></i>
                          }
                          @if (!c.href && !c.linkDsl && !isBool(c.value)) {
                            <span>{{ c.value }}</span>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
</div>
}
